import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';

import { Select } from '@material-ui/core';
import { Field } from 'formik';

export enum DegreeTypeEnum {
  近用 = 0,
  両用 = 1,
  遠用 = 2,
};

interface Props {
  degreeType: number | undefined,
  onChange: (degreeType: number) => void,
}

export default ((props) => {
  let selectedDegreeType = props.degreeType !== undefined ? props.degreeType : -1;

  useEffect(() => {
    if (props.degreeType === undefined) {
      props.onChange(selectedDegreeType);
    }
  }, [props, selectedDegreeType]);

  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    props.onChange(Number(event.target.value));
  };

  const degreeTypes = Object.entries(DegreeTypeEnum).filter(([key]) => { return (Number(key) === DegreeTypeEnum.遠用 || Number(key) === DegreeTypeEnum.近用 || Number(key) === DegreeTypeEnum.両用) });

  return (
      <Field style={{ fontSize: 13, maxWidth: 140, }} required fullWidth name='DegreeType' label='Degree Type' id='DegreeType' value={selectedDegreeType} onChange={handleSelectChange} component={Select} >
        {degreeTypes.map(([key, value]) => (
          <MenuItem key={key} value={key}>{value}</MenuItem>
        ))}
      </Field >
  );
}) as React.FC<Props>;